import React from 'react';
import { StateLanguage } from '../../languages/config/StateLanguage';

export interface AppNoneProps {
  condition: boolean,
  display: string,
};

const AppNone: React.FunctionComponent<AppNoneProps> = ({condition, display}) => {
  const {lang} = StateLanguage()

  return (
    <>
      { condition
        ?
        display
        :
        <small>{lang.labels.none}</small>
      }
    </>
  )
}

export default AppNone;
